import { Button, Icon } from '../../../../shared';
import './steps.scss';

type Props = {
  isSummaryOpen: boolean;
  isLastStep: boolean;
  onNext: () => void;
  onPrev: () => void;
};
export const StepNavigationButtons: React.FC<Props> = ({ isSummaryOpen, isLastStep, onNext, onPrev }) => (
  <nav className="step-navigation container padded wide" aria-hidden={isSummaryOpen}>
    {!isLastStep && (
      <Button type="primary blue" iconMargin="left" aria-label="Neste steg" onClick={onNext}>
        Neste
        <Icon type="arrow" fill="white" size={1.5} />
      </Button>
    )}
    {!isLastStep && (
      <Button type="primary blue" iconMargin="right" aria-label="Tilbake til forrige steg" onClick={onPrev}>
        <Icon type="arrow" flip="horizontal" fill="white" size={1.5} />
        Tilbake
      </Button>
    )}
  </nav>
);
